import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shared-text-separator',
  standalone: true,
  imports: [],
  template: `<div class="h-1.5 w-1.5 rounded-full bg-neutral-200"></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextSeparatorComponent {}
